import { useCallback, useEffect, useState } from 'react';
import { withErrorBoundary } from 'react-error-boundary';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';

import * as routing from '../../../constants/Routing';
import { Project } from '../../../domain/project/Project';
import ProjectAnalyticsDriversAverageDelays from './ProjectAnalyticsDriversAverageDelays';
import ProjectAnalyticsDriversDeliveryAttempts from './ProjectAnalyticsDriversDeliveryAttempts';
import ProjectAnalyticsDriversRouteTracking from './ProjectAnalyticsDriversRouteTracking';
import ProjectAnalyticsDriversSatisfaction from './ProjectAnalyticsDriversSatisfaction';
import ProjectAnalyticsDriversTimeOnRoute from './ProjectAnalyticsDriversTimeOnRoute';

interface ProjectAnalyticsDriversProps {
  project: Project;
}

const ProjectAnalyticsDrivers = ({ project }: ProjectAnalyticsDriversProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [currentView, setCurrentView] = useState<string>(``);

  const setLocationView = useCallback(
    (view: string) => {
      if (view !== currentView) {
        setCurrentView(view);
        navigate(`${view.replace(`:projectId`, `${project?.id}`)}`);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentView, project?.id]
  );

  useEffect(() => {
    if (!!location && location.pathname !== ``) {
      if (
        location.pathname.indexOf(routing.PROJECT_ANALYTICS.DRIVERS.TIME_ON_ROUTE.replace(`/h/:projectId`, ``)) ===
          -1 &&
        location.pathname.indexOf(routing.PROJECT_ANALYTICS.DRIVERS.DELIVERY_DELAYS.replace(`/h/:projectId`, ``)) ===
          -1 &&
        location.pathname.indexOf(routing.PROJECT_ANALYTICS.DRIVERS.ROUTE_TRACKING.replace(`/h/:projectId`, ``)) ===
          -1 &&
        location.pathname.indexOf(routing.PROJECT_ANALYTICS.DRIVERS.DELIVERY_ATTEMPTS.replace(`/h/:projectId`, ``)) ===
          -1 &&
        location.pathname.indexOf(routing.PROJECT_ANALYTICS.DRIVERS.SATISFACTION.replace(`/h/:projectId`, ``)) === -1
      ) {
        setLocationView(routing.PROJECT_ANALYTICS.DRIVERS.TIME_ON_ROUTE);
      }
    }
  }, [location, setLocationView]);

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/time-on-route" />} />

      <Route path="/time-on-route" element={<ProjectAnalyticsDriversTimeOnRoute />} />
      <Route path="/delivery-delays" element={<ProjectAnalyticsDriversAverageDelays />} />
      <Route path="/route-tracking" element={<ProjectAnalyticsDriversRouteTracking />} />
      <Route path="/delivery-attempts" element={<ProjectAnalyticsDriversDeliveryAttempts />} />
      <Route path="/satisfaction" element={<ProjectAnalyticsDriversSatisfaction />} />

      <Route
        path="*"
        element={
          <Navigate to={`${routing.PROJECT_ANALYTICS.DRIVERS.TIME_ON_ROUTE.replace(`:projectId`, project.id)}`} />
        }
      />
    </Routes>
  );
};

export default withErrorBoundary(ProjectAnalyticsDrivers, {
  FallbackComponent: () => <span>There has been an error</span>,
  onError: (error: Error, info: { componentStack: string }) => {
    // Do something with the error
    // E.g. log to an error logging client here

    console.info(`error, info`, error, info);
  },
});
